import mixpanel from 'mixpanel-browser'

export const isDevMode =
  process.env.NODE_ENV === 'local'
  || process.env.NODE_ENV === 'development'
  || process.env.VUE_APP_STAGE === 'local'

const MIXPANEL_TOKEN = process.env.VUE_APP_MIXPANEL_TOKEN
/**
 * Logs mixpanel events in a dev environment
 *
 * @see https://developer.mixpanel.com/docs/javascript
 *
 * @param {string} name - Mixpanel function being invoked
 * @param {Function} func - Mixpanel function reference
 */
function mixpanelProxyFunction(name, func) {
  return (...args) => {
    console.info(`MixPanel [${name}]`, args)
    /** Only fire the function to mixpanel if we have a token */
    if (MIXPANEL_TOKEN) {
      return func.call(this, ...args)
    }
  }
}

/**
 * A Proxy configuration object.
 *
 * Essentially, when doing `obj = new Proxy(target, config)`
 * then every request to `obj[prop]` will fire the get()
 *
 * We use this to intercept all `MixPanel.func()` calls and
 * log them to the console (if in dev mode)
 */
const ProxyGetter = {
  get(target, prop) {
    if (!(prop in target)) {
      return
    }
    const p = target[prop]
    /**
     * Not all objects on mixpanel may be functions, so we need
     * to return a new Proxy.
     */
    if (p && typeof p === 'object') {
      return new Proxy(p, ProxyGetter)
    }
    if (isDevMode) {
      return mixpanelProxyFunction.call(mixpanel, prop, p)
    }
    if (MIXPANEL_TOKEN) {
      return p
    }
    /** If we're not in dev mode and we don't have a token... */
    if (prop === 'init') {
      console.error('MixPanel token is missing from this environment.')
    }
    return () => {}
  }
}

export const Analytics = new Proxy(mixpanel, ProxyGetter)
